export type SettingsSection = 'notifications' | 'templates' | 'logs' | 'api-keys' | 'stock-sync' | 'onec-sync' | 'marketplace-prices'

export const SETTINGS_SECTIONS: ReadonlyArray<{ id: SettingsSection; label: string }> = [
  { id: 'notifications', label: 'Уведомления' },
  { id: 'templates', label: 'Шаблоны сообщений' },
  { id: 'logs', label: 'Журналы сервисов' },
  { id: 'api-keys', label: 'API-ключи' },
  { id: 'stock-sync', label: 'Синхронизация остатков' },
  { id: 'onec-sync', label: 'Синхронизация с 1С' },
  { id: 'marketplace-prices', label: 'Цены на Маркете' },
]

export function SettingsSectionNavigation({ section, onSelect }: { section: SettingsSection; onSelect: (section: SettingsSection) => void }) {
  return (
    <nav aria-label="Разделы настроек" className="space-y-1">
      {SETTINGS_SECTIONS.map((item) => (
        <button
          key={item.id}
          type="button"
          onClick={() => onSelect(item.id)}
          aria-current={section === item.id ? 'page' : undefined}
          className={`w-full rounded-md border-l-2 px-3 py-2.5 text-left text-[13px] transition-colors ${section === item.id ? 'border-gold bg-bone font-semibold text-ink' : 'border-transparent text-ink-2 hover:bg-bone/60 hover:text-ink'}`}
        >
          {item.label}
        </button>
      ))}
    </nav>
  )
}
